import React, { useEffect, lazy, memo, createElement } from 'react';
import { Star, Heart, Check, ShieldCheck, Sparkles, MapPin, Instagram, Volume2, Navigation, ExternalLink } from 'lucide-react';
import { Button } from '../components/ui/Button';
import { Section } from '../components/ui/Section';
import { Accordion } from '../components/ui/Accordion';
import { PriceCard } from '../components/ui/PriceCard';
import { AnimatedFlagBackground } from '../components/AnimatedFlagBackground';
import { StickySpotCounter } from '../components/StickySpotCounter';
import { SEO } from '../components/SEO';
export function SalesPage() {
  useEffect(() => {
    document.title = 'Aquí entre Mujeres by Kate Castrillon';
    let link = document.querySelector("link[rel~='icon']") as HTMLLinkElement;
    if (!link) {
      link = document.createElement('link');
      link.rel = 'icon';
      document.getElementsByTagName('head')[0].appendChild(link);
    }
    link.href = 'https://cdn.magicpatterns.com/uploads/jomajo3SSHHmkh5xF5a7j2/KATE_4Landingpage.png';
  }, []);
  const scrollToOffer = () => {
    const element = document.getElementById('price-card');
    element?.scrollIntoView({
      behavior: 'smooth',
      block: 'center'
    });
  };
  return <div className="min-h-screen w-full bg-brand-ivory selection:bg-brand-clay/30 selection:text-brand-clay relative font-sans text-brand-text" data-id="element-72">
      <SEO title="Aquí entre Mujeres by Kate Castrillon" description="Un encuentro íntimo y profundamente femenino para la mujer que ya no quiere seguir igual. Evento presencial en Costa Rica." image="https://cdn.magicpatterns.com/uploads/jomajo3SSHHmkh5xF5a7j2/KATE_4Landingpage.png" data-id="element-73" />
      <AnimatedFlagBackground data-id="element-74" />

      {/* HERO SECTION */}
      <header className="relative w-full overflow-hidden bg-brand-dark/85 backdrop-blur-[2px] text-white z-10 shadow-xl" data-id="element-75">
        <div className="absolute inset-0 bg-gradient-to-b from-brand-dark/60 via-transparent to-brand-dark/80 mix-blend-multiply" data-id="element-76"></div>

        <div className="relative max-w-6xl mx-auto px-4 pt-20 pb-16 md:pt-28 md:pb-24 flex flex-col md:flex-row items-center gap-12" data-id="element-77">
          <div className="flex-1 text-center md:text-left z-10" data-id="element-78">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-white/15 border border-white/20 text-white text-xs font-medium tracking-widest uppercase mb-6 backdrop-blur-sm" data-id="element-79">
              <MapPin className="h-3 w-3" data-id="element-80" /> Evento Presencial — Costa Rica
            </div>
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-serif font-bold leading-tight mb-6 text-brand-ivory" data-id="element-81">
              Este espacio no es para todas... <br data-id="element-82" />
              <span className="text-brand-clay italic" data-id="element-83">¿pero es para ti?</span>
            </h1>
            <p className="text-lg md:text-xl text-brand-pistachio mb-8 max-w-xl leading-relaxed" data-id="element-84">
              Un encuentro íntimo y profundamente femenino para la mujer que ya
              no quiere seguir igual.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center md:justify-start" data-id="element-85">
              <Button variant="primary" size="lg" onClick={scrollToOffer} className="shadow-lg shadow-brand-clay/20" data-id="element-86">
                Reserva tu cupo ahora
              </Button>
              <Button variant="outline" size="lg" className="text-white border-white hover:bg-white/10 focus:ring-white" onClick={() => document.getElementById('problem')?.scrollIntoView({
              behavior: 'smooth'
            })} data-id="element-87">
                Leer más
              </Button>
            </div>

            {/* WhatsApp Button */}
            <button onClick={() => window.open('https://wa.me/50688118105?text=Quiero%20m%C3%A1s%20informaci%C3%B3n%20sobre%20el%20evento%3A%20Un%20encuentro%20%C3%ADntimo%2C%20con%20Kate', '_blank')} className="mt-4 inline-flex items-center justify-center gap-3 px-6 py-3 bg-[#25D366] hover:bg-[#20BA5A] text-white rounded-full font-medium transition-all duration-300 shadow-lg hover:shadow-xl focus:outline-none focus:ring-2 focus:ring-[#25D366] focus:ring-offset-2" data-id="element-88">
              <svg viewBox="0 0 24 24" className="h-5 w-5" fill="currentColor" data-id="element-89">
                <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z" data-id="element-90" />
              </svg>
              <span data-id="element-91">¿Quieres saber si es para ti?</span>
            </button>
          </div>

          <div className="flex-1 relative max-w-md w-full" data-id="element-92">
            <div className="absolute -inset-4 bg-brand-clay/20 rounded-[2rem] blur-xl md:blur-2xl transform rotate-3" data-id="element-93"></div>
            <div className="relative rounded-[2rem] overflow-hidden shadow-2xl border-4 border-white/20" data-id="element-94">
              <img src="https://cdn.magicpatterns.com/uploads/jomajo3SSHHmkh5xF5a7j2/KATE_4Landingpage.png" alt="Kate Castrillon - Aquí entre Mujeres" className="w-full h-auto object-cover" loading="eager" decoding="async" data-id="element-95" />
            </div>
            <p className="text-white/90 font-serif text-xl md:text-2xl italic text-center mt-6" data-id="element-96">
              "No necesitas arreglarte, necesitas volver a ti."
            </p>
          </div>
        </div>
      </header>

      {/* PROBLEM AWARENESS */}
      <Section id="problem" background="white" data-id="element-97">
        <div className="text-center max-w-3xl mx-auto mb-12" data-id="element-98">
          <Heart className="h-8 w-8 text-brand-clay mx-auto mb-6" data-id="element-99" />
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-brand-dark mb-6" data-id="element-100">
            Hay un cansancio que no se quita con dormir.
          </h2>
          <p className="text-lg text-brand-text leading-relaxed mb-6" data-id="element-101">
            Ni con "pensar positivo". Ni con aguantar un poquito más. Es ese
            cansancio de{' '}
            <strong className="text-brand-clay" data-id="element-102">
              ser fuerte todo el tiempo
            </strong>
            , de sostener a todos, de cumplir… mientras por dentro sientes que
            algo en ti pide auxilio.
          </p>
          <p className="text-lg text-brand-text leading-relaxed" data-id="element-103">
            Y lo peor no es la tristeza. Lo peor es esa sensación de que tu vida
            sigue avanzando… pero tú sigues igual.
          </p>
        </div>

        <div className="bg-brand-pistachio/30 rounded-3xl p-8 md:p-12 my-12 border border-brand-eucalyptus/30" data-id="element-104">
          <h3 className="text-2xl font-serif font-bold text-brand-dark mb-8 text-center" data-id="element-105">
            Si esto te incomoda… probablemente es para ti
          </h3>
          <div className="grid md:grid-cols-2 gap-6" data-id="element-106">
            {['Estoy bien… pero no me siento bien.', 'Hago demasiado y aun así siento que no avanzo.', 'Quiero cambiar, pero me cuesta sostenerlo.', 'Estoy cansada de repetir los mismos patrones.'].map((item, i) => <div key={i} className="flex items-start gap-4 bg-white/80 p-4 rounded-xl shadow-sm border border-brand-ivory" data-id="element-107">
                <div className="h-6 w-6 rounded-full bg-brand-eucalyptus/30 flex items-center justify-center flex-shrink-0 mt-0.5" data-id="element-108">
                  <div className="h-2 w-2 rounded-full bg-brand-clay" data-id="element-109"></div>
                </div>
                <p className="text-brand-dark font-medium" data-id="element-110">{item}</p>
              </div>)}
          </div>
          <div className="mt-10 text-center" data-id="element-111">
            <p className="text-xl font-serif italic text-brand-dark/80" data-id="element-112">
              "No es que te falte fuerza. Es que estás cargando cosas que no
              tendrías que estar cargando."
            </p>
            <div className="mt-8" data-id="element-113">
              <Button variant="primary" size="lg" onClick={scrollToOffer} className="shadow-lg shadow-brand-clay/20" data-id="element-114">
                Quiero reservar mi cupo
              </Button>
            </div>
          </div>
        </div>
      </Section>

      {/* THE INVISIBLE LOAD */}
      <Section background="light" data-id="element-115">
        <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-116">
          <div data-id="element-117">
            <h2 className="text-3xl md:text-4xl font-serif font-bold text-brand-dark mb-6" data-id="element-118">
              La "carga invisible"
            </h2>
            <p className="text-lg text-brand-text mb-6" data-id="element-119">
              Es invisible porque nadie la mide. Pero tú la sientes en el pecho
              apretado cuando estás sola, en la mente que no se apaga, en el
              "sí" que dices por costumbre y en la culpa cuando descansas.
            </p>
            <p className="text-lg text-brand-text mb-8" data-id="element-120">
              Cuando una mujer lleva eso por meses (o años), se vuelve experta
              en funcionar. Y se olvida de lo que se siente estar en paz.
            </p>
            <div className="space-y-4" data-id="element-121">
              <h4 className="font-bold text-brand-clay uppercase tracking-wide text-sm" data-id="element-122">
                El resultado que quieres:
              </h4>
              <ul className="space-y-3" data-id="element-123">
                {['Sentir ligereza sin sentir culpa', 'Tomar decisiones con seguridad', 'Reconciliarte con el dinero y el merecimiento', 'Soltar lo que no es tuyo', 'Habitar tu energía femenina sin vergüenza'].map((item, i) => <li key={i} className="flex items-center gap-3 text-brand-dark" data-id="element-124">
                    <Check className="h-5 w-5 text-brand-eucalyptus" data-id="element-125" />
                    {item}
                  </li>)}
              </ul>
            </div>
          </div>
          <div className="relative" data-id="element-126">
            <div className="absolute -inset-4 bg-brand-peach rounded-full opacity-30 md:blur-3xl md:opacity-50" data-id="element-127"></div>
            <img src="https://images.unsplash.com/photo-1506126613408-eca07ce68773?q=60&w=800&auto=format&fit=crop" alt="Mujer en paz y libertad" className="relative rounded-2xl shadow-xl w-full h-auto object-cover aspect-[4/5]" loading="lazy" decoding="async" sizes="(max-width: 768px) 100vw, 50vw" data-id="element-128" />
          </div>
        </div>
      </Section>

      {/* THE SOLUTION */}
      <Section background="white" data-id="element-129">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-130">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-brand-dark mb-4" data-id="element-131">
            El Reset Femenino
          </h2>
          <p className="text-xl text-brand-clay font-medium" data-id="element-132">
            Ordenar → Soltar → Elegirte
          </p>
          <div className="w-24 h-1 bg-brand-eucalyptus mx-auto mt-6 rounded-full" data-id="element-133"></div>
        </div>

        <div className="grid md:grid-cols-3 gap-8" data-id="element-134">
          {[{
          step: '01',
          title: 'Ordenar',
          desc: "Emociones y energía. No para 'controlarte', sino para volver a escucharte sin ruido."
        }, {
          step: '02',
          title: 'Soltar',
          desc: 'Cargas invisibles que no te pertenecen: expectativas, culpas, exigencias, roles, lealtades.'
        }, {
          step: '03',
          title: 'Elegirte',
          desc: "Decidir desde tu verdad. No desde el miedo. No desde la complacencia. No desde el 'después'."
        }].map((card, i) => <div key={i} className="bg-brand-ivory p-8 rounded-2xl border border-brand-pistachio shadow-lg hover:shadow-xl transition-shadow relative overflow-hidden group" data-id="element-135">
              <div className="absolute top-0 right-0 p-4 opacity-10 font-serif text-9xl font-bold text-brand-clay -mr-4 -mt-4 group-hover:scale-110 transition-transform" data-id="element-136">
                {card.step}
              </div>
              <div className="relative z-10" data-id="element-137">
                <span className="text-brand-clay font-bold tracking-widest text-sm mb-2 block" data-id="element-138">
                  PASO {card.step}
                </span>
                <h3 className="text-2xl font-serif font-bold text-brand-dark mb-4" data-id="element-139">
                  {card.title}
                </h3>
                <p className="text-brand-text leading-relaxed" data-id="element-140">{card.desc}</p>
              </div>
            </div>)}
        </div>

        <div className="mt-16 bg-brand-peach/30 rounded-2xl p-8 md:p-10 flex flex-col md:flex-row items-center gap-8 border border-brand-peach" data-id="element-141">
          <div className="flex-1" data-id="element-142">
            <h3 className="text-2xl font-serif font-bold text-brand-clay mb-4" data-id="element-143">
              Sanación de útero
            </h3>
            <p className="text-brand-dark/80 leading-relaxed" data-id="element-144">
              Este proceso toca una raíz profunda. Porque el cuerpo guarda lo
              que la mente quiere "superar rápido". Trabajaremos con respeto y
              claridad para liberar memorias y potenciar tu creatividad y
              merecimiento.
            </p>
          </div>
          <div className="flex-shrink-0" data-id="element-145">
            <div className="h-24 w-24 rounded-full bg-brand-peach flex items-center justify-center" data-id="element-146">
              <Sparkles className="h-10 w-10 text-brand-clay" data-id="element-147" />
            </div>
          </div>
        </div>
      </Section>

      {/* KATE'S PERSONAL AUDIO MESSAGE */}
      <Section background="accent" data-id="element-148">
        <div className="max-w-2xl mx-auto text-center" data-id="element-149">
          <div className="flex justify-center mb-6" data-id="element-150">
            <div className="relative" data-id="element-151">
              <div className="absolute -inset-1 bg-brand-clay/30 rounded-full blur-md" data-id="element-152"></div>
              <img src="https://cdn.magicpatterns.com/uploads/jomajo3SSHHmkh5xF5a7j2/KATE_4Landingpage.png" alt="Kate Castrillon" className="relative h-20 w-20 rounded-full object-cover border-3 border-brand-ivory shadow-lg" loading="lazy" decoding="async" data-id="element-153" />
            </div>
          </div>
          <h3 className="text-2xl font-serif font-bold text-brand-dark mb-2" data-id="element-154">
            Un mensaje de Kate para ti
          </h3>
          <p className="text-brand-text text-sm mb-6 flex items-center justify-center gap-1.5" data-id="element-155">
            <Volume2 className="h-4 w-4 text-brand-clay" data-id="element-156" />
            Escúchalo, es personal
          </p>
          <div className="bg-white rounded-2xl p-6 shadow-lg border border-brand-pistachio" data-id="element-157">
            <audio controls className="w-full" preload="metadata" data-id="element-158">
              <source src="https://raw.githubusercontent.com/jvzng/webpage_chatbot_closer/8285e116406af340b0cf7af9f5b9e480d1849080/Kate%20audio%204landing%20page.MP3" type="audio/mpeg" data-id="element-159" />
              Tu navegador no soporta el reproductor de audio.
            </audio>
          </div>
        </div>
      </Section>

      {/* OFFER SECTION */}
      <Section id="offer" background="dark" className="relative overflow-hidden" data-id="element-160">
        <div className="relative z-10 grid lg:grid-cols-2 gap-12 items-center" data-id="element-161">
          <div className="text-white" data-id="element-162">
            <h2 className="text-3xl md:text-5xl font-serif font-bold mb-6" data-id="element-163">
              Un encuentro íntimo para transformar tu realidad
            </h2>
            <p className="text-brand-pistachio text-lg mb-8 leading-relaxed" data-id="element-164">
              Este espacio no es masivo porque esto no se trabaja en masa. La
              transformación real necesita presencia, contención y enfoque. Si
              estás leyendo esto y sientes ese "sí" por dentro… no lo negocies
              con tu miedo.
            </p>

            <div className="space-y-6 mb-10" data-id="element-165">
              <div className="flex items-start gap-4" data-id="element-166">
                <div className="h-10 w-10 rounded-full bg-brand-clay flex items-center justify-center flex-shrink-0 border border-brand-peach" data-id="element-167">
                  <ShieldCheck className="h-5 w-5 text-white" data-id="element-168" />
                </div>
                <div data-id="element-169">
                  <h4 className="font-bold text-lg text-white" data-id="element-170">
                    Espacio Seguro
                  </h4>
                  <p className="text-brand-pistachio text-sm" data-id="element-171">
                    Solo mujeres, sin juicios, confidencialidad total.
                  </p>
                </div>
              </div>
              <div className="flex items-start gap-4" data-id="element-172">
                <div className="h-10 w-10 rounded-full bg-brand-clay flex items-center justify-center flex-shrink-0 border border-brand-peach" data-id="element-173">
                  <Star className="h-5 w-5 text-white" data-id="element-174" />
                </div>
                <div data-id="element-175">
                  <h4 className="font-bold text-lg text-white" data-id="element-176">
                    Experiencia Premium
                  </h4>
                  <p className="text-brand-pistachio text-sm" data-id="element-177">
                    Materiales incluidos, coffee break, ubicación exclusiva.
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="flex justify-center" data-id="element-178">
            <PriceCard data-id="element-179" />
          </div>
        </div>
      </Section>

      {/* FILTER: WHO IS THIS FOR */}
      <Section background="white" data-id="element-180">
        <div className="grid md:grid-cols-2 gap-8 md:gap-12" data-id="element-181">
          <div className="bg-brand-eucalyptus/20 p-8 rounded-3xl border border-brand-eucalyptus/40" data-id="element-182">
            <h3 className="text-xl font-serif font-bold text-brand-dark mb-6 flex items-center gap-2" data-id="element-183">
              <Check className="h-6 w-6 text-brand-clay" data-id="element-184" /> Para quién SÍ es
            </h3>
            <ul className="space-y-4" data-id="element-185">
              {['Estás cansada de cargar con todo en silencio', "Sientes que ya entendiste 'mucho', pero te falta sostener el cambio", 'Quieres un espacio femenino real, íntimo, sin juicio', 'Estás lista para soltar versiones viejas de ti'].map((item, i) => <li key={i} className="flex items-start gap-3 text-brand-dark/80" data-id="element-186">
                  <div className="h-1.5 w-1.5 rounded-full bg-brand-clay mt-2 flex-shrink-0" data-id="element-187"></div>
                  {item}
                </li>)}
            </ul>
          </div>

          <div className="bg-red-50 p-8 rounded-3xl border border-red-100" data-id="element-188">
            <h3 className="text-xl font-serif font-bold text-red-800 mb-6 flex items-center gap-2" data-id="element-189">
              <span className="text-2xl leading-none" data-id="element-190">×</span> Para quién NO es
            </h3>
            <ul className="space-y-4" data-id="element-191">
              {["Solo quieres 'una charla motivacional'", 'Quieres cambiar sin tocar nada incómodo', 'Vienes a complacer a alguien más', 'Buscas una solución mágica sin compromiso personal'].map((item, i) => <li key={i} className="flex items-start gap-3 text-red-900/80" data-id="element-192">
                  <div className="h-1.5 w-1.5 rounded-full bg-red-400 mt-2 flex-shrink-0" data-id="element-193"></div>
                  {item}
                </li>)}
            </ul>
          </div>
        </div>

        <div className="mt-12 text-center" data-id="element-194">
          <Button variant="primary" size="lg" onClick={scrollToOffer} className="shadow-lg shadow-brand-clay/20" data-id="element-195">
            Quiero reservar mi cupo
          </Button>
        </div>
      </Section>

      {/* FAQ */}
      <Section background="light" data-id="element-196">
        <div className="text-center mb-12" data-id="element-197">
          <h2 className="text-3xl font-serif font-bold text-brand-dark mb-4" data-id="element-198">
            Preguntas Frecuentes
          </h2>
          <p className="text-brand-text" data-id="element-199">
            Todo lo que necesitas saber antes de reservar
          </p>
        </div>
        <div className="max-w-3xl mx-auto" data-id="element-200">
          <Accordion items={[{
          title: '¿Y si me da pena ir sola?',
          content: 'La mayoría llega sola. Este es un espacio diseñado para que te sientas cuidada, no expuesta. Desde el primer momento sentirás la contención del grupo y del equipo.'
        }, {
          title: '¿Esto es terapia?',
          content: 'No es terapia clínica. Es un evento presencial de sanación y desarrollo personal con un proceso guiado y contenido práctico diseñado para generar cambios profundos en poco tiempo.'
        }, {
          title: '¿Y si estoy en un momento muy sensible?',
          content: 'Precisamente por eso es solo mujeres y con cupos limitados: para sostener el proceso con respeto. No te obligaremos a nada que no quieras hacer.'
        }, {
          title: "¿Qué pasa si 'me remueve' cosas?",
          content: 'Ese es el punto: mover para liberar. Pero lo hacemos con guía y estructura, no para abrir y dejarte peor, sino para que salgas más ligera y ordenada.'
        }, {
          title: '¿Cuáles son los métodos de pago?',
          content: 'Aceptamos tarjetas de crédito/débito, PayPal y transferencia bancaria. Todos los detalles estarán disponibles al momento de reservar tu cupo.'
        }]} data-id="element-201" />
        </div>
      </Section>

      {/* LOCATION SECTION */}
      <Section background="peach" data-id="element-202">
        <div className="text-center mb-10" data-id="element-203">
          <MapPin className="h-8 w-8 text-brand-clay mx-auto mb-4" data-id="element-204" />
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-brand-dark mb-3" data-id="element-205">
            ¿Dónde será el evento?
          </h2>
          <p className="text-brand-text text-lg" data-id="element-206">
            Un espacio holístico, íntimo y lleno de paz
          </p>
        </div>

        <div className="max-w-3xl mx-auto" data-id="element-207">
          {/* Map Embed */}
          <div className="rounded-2xl overflow-hidden shadow-xl border border-brand-pistachio mb-8" data-id="element-208">
            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3929.5!2d-84.1846049!3d10.0180594!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8fa0fb83f2b8a43f%3A0x3bb430997c2d8754!2sEsfera%20Espacio%20Hol%C3%ADstico!5e0!3m2!1ses!2scr!4v1700000000000!5m2!1ses!2scr" width="100%" height="280" style={{
            border: 0
          }} allowFullScreen loading="lazy" referrerPolicy="no-referrer-when-downgrade" title="Ubicación - Esfera Espacio Holístico" className="w-full md:h-[350px]" data-id="element-209" />
          </div>

          {/* Location Details */}
          <div className="bg-white/80 rounded-2xl p-6 md:p-8 border border-brand-pistachio shadow-md mb-8" data-id="element-210">
            <div className="flex items-start gap-4 mb-4" data-id="element-211">
              <div className="h-12 w-12 rounded-full bg-brand-eucalyptus/30 flex items-center justify-center flex-shrink-0" data-id="element-212">
                <MapPin className="h-6 w-6 text-brand-clay" data-id="element-213" />
              </div>
              <div data-id="element-214">
                <h3 className="text-xl font-serif font-bold text-brand-dark" data-id="element-215">
                  Esfera Espacio Holístico
                </h3>
                <p className="text-brand-text mt-1" data-id="element-216">
                  Costa Rica 🇨🇷 — Un lugar rodeado de naturaleza, diseñado para
                  la conexión y la sanación.
                </p>
              </div>
            </div>
          </div>

          {/* Navigation Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center" data-id="element-217">
            <button onClick={() => window.open('https://www.google.com/maps/dir/?api=1&destination=10.0180594,-84.1846049&destination_place_id=ChIJP6S48oP7oI8RVIdNfJkwtDs', '_blank')} className="inline-flex items-center justify-center gap-3 px-6 py-3.5 bg-white rounded-full border border-brand-pistachio shadow-md hover:shadow-lg hover:border-brand-clay/30 transition-all duration-300 text-brand-dark font-medium" data-id="element-218">
              <svg viewBox="0 0 24 24" className="h-5 w-5" fill="none" data-id="element-219">
                <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7z" fill="#4285F4" data-id="element-220" />
                <circle cx="12" cy="9" r="2.5" fill="white" data-id="element-221" />
              </svg>
              <span data-id="element-222">Abrir en Google Maps</span>
              <ExternalLink className="h-4 w-4 text-brand-text/50" data-id="element-223" />
            </button>

            <button onClick={() => window.open('https://waze.com/ul?ll=10.0180594,-84.1846049&navigate=yes', '_blank')} className="inline-flex items-center justify-center gap-3 px-6 py-3.5 bg-white rounded-full border border-brand-pistachio shadow-md hover:shadow-lg hover:border-brand-clay/30 transition-all duration-300 text-brand-dark font-medium" data-id="element-224">
              <svg viewBox="0 0 24 24" className="h-5 w-5" fill="none" data-id="element-225">
                <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2z" fill="#33CCFF" data-id="element-226" />
                <circle cx="9" cy="11" r="1.2" fill="#333" data-id="element-227" />
                <circle cx="15" cy="11" r="1.2" fill="#333" data-id="element-228" />
                <path d="M8.5 15c.83 1.17 2.08 1.5 3.5 1.5s2.67-.33 3.5-1.5" stroke="#333" strokeWidth="1.2" strokeLinecap="round" fill="none" data-id="element-229" />
              </svg>
              <span data-id="element-230">Abrir en Waze</span>
              <Navigation className="h-4 w-4 text-brand-text/50" data-id="element-231" />
            </button>
          </div>
        </div>
      </Section>

      {/* FINAL CTA */}
      <footer className="bg-brand-dark text-white py-20 px-4 text-center pb-28" data-id="element-232">
        <div className="max-w-3xl mx-auto" data-id="element-233">
          <h2 className="text-3xl md:text-5xl font-serif font-bold mb-6" data-id="element-234">
            Si ya te cansaste de seguir igual, este es el punto de quiebre.
          </h2>
          <p className="text-xl text-brand-pistachio mb-10" data-id="element-235">
            Porque tu paz no se consigue "cuando todo se calme". <br data-id="element-236" />
            Se consigue cuando tú decides.
          </p>
          <Button variant="secondary" size="lg" className="text-lg px-12 py-5 shadow-2xl shadow-brand-clay/20 bg-brand-clay text-white hover:bg-[#C89268]" onClick={() => window.open('https://pay.hotmart.com/A104324565P?off=pi9fadac', '_blank')} data-id="element-237">
            Reserva tu cupo ahora
          </Button>
          <p className="mt-8 text-sm text-brand-eucalyptus" data-id="element-238">
            Evento SOLO MUJERES — 14 de Marzo — Costa Rica 🇨🇷 — Cupos limitados
          </p>
          <a href="https://www.instagram.com/katecastrillonb/" target="_blank" rel="noopener noreferrer" onClick={e => {
          e.preventDefault();
          window.open('https://www.instagram.com/katecastrillonb/', '_blank');
        }} className="relative z-20 inline-flex items-center gap-2 mt-6 text-brand-pistachio hover:text-white transition-colors group cursor-pointer" data-id="element-239">
            <Instagram className="h-5 w-5 group-hover:scale-110 transition-transform" data-id="element-240" />
            <span className="text-sm font-medium" data-id="element-241">@katecastrillonb</span>
          </a>
        </div>
      </footer>

      {/* Sticky Spot Counter */}
      <StickySpotCounter data-id="element-242" />
    </div>;
}